export function roundOrNull (value) {
  // console.log('round', value)
  if (value === null) {
    return null
  }

  if (typeof value === 'undefined') {
    return null
  }

  return Math.round(value)
}
